import { RootRoutes } from '../../../constants';

export const SurveyRoutes = {
	Root: `${RootRoutes.Survey}/:urlHash`,
	QrCodeRoot: `${RootRoutes.Survey}/qr/:qrId`,
	ManualEditing: `${RootRoutes.Survey}/manual-editing/:familyId/:surveyId`,
};
